import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'

export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
export const PaddedDivContent = styled(Flex)`
  padding-left: 4%;
  margin-top: -5rem;
  align-items: center;
  gap: 25px;
`
export const PaddedDivContentLeft = styled(Flex)`
  padding-left: 5%;
  margin-top: -5rem;
  align-items: center;
  gap: 25px;
`
export const SectionWrapper = styled(Flex)`
  width: 100%;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #4d566e;
`
export const CardRow = styled(Flex)`
  gap: 25px;
`
export const EmptyWrapper = styled(Flex)`
  margin: 50px 0px;
  margin: ${props => props?.isSpin && '102px 0px'};
`

export const PaddedDivChart = styled(Flex)`
  padding: 20px 25px;
  gap: 50px;
  margin-right: 5rem;
  margin-left: 4rem;
`
